import {useTranslation} from "react-i18next";

export const useTimeZoneIds = () => {
    const {t} = useTranslation();
    return [
        {label: t('UTC'), value: 'UTC'},

        {label: t('America/New_York'), value: 'America/New_York'},
        {label: t('America/Chicago'), value: 'America/Chicago'},
        {label: t('America/Denver'), value: 'America/Denver'},
        {label: t('America/Los_Angeles'), value: 'America/Los_Angeles'},
        {label: t('America/Phoenix'), value: 'America/Phoenix'},
        {label: t('America/Anchorage'), value: 'America/Anchorage'},
        {label: t('Pacific/Honolulu'), value: 'Pacific/Honolulu'},
        {label: t('America/Toronto'), value: 'America/Toronto'},
        {label: t('America/Vancouver'), value: 'America/Vancouver'},
        {label: t('America/Halifax'), value: 'America/Halifax'},
        {label: t('America/St_Johns'), value: 'America/St_Johns'},
        {label: t('America/Mexico_City'), value: 'America/Mexico_City'},
        {label: t('America/Tijuana'), value: 'America/Tijuana'},
        {label: t('America/Guatemala'), value: 'America/Guatemala'},
        {label: t('America/Panama'), value: 'America/Panama'},
        {label: t('America/Bogota'), value: 'America/Bogota'},
        {label: t('America/Lima'), value: 'America/Lima'},
        {label: t('America/Santiago'), value: 'America/Santiago'},
        {label: t('America/Argentina/Buenos_Aires'), value: 'America/Argentina/Buenos_Aires'},
        {label: t('America/Sao_Paulo'), value: 'America/Sao_Paulo'},

        {label: t('Europe/London'), value: 'Europe/London'},
        {label: t('Europe/Dublin'), value: 'Europe/Dublin'},
        {label: t('Europe/Lisbon'), value: 'Europe/Lisbon'},
        {label: t('Europe/Madrid'), value: 'Europe/Madrid'},
        {label: t('Europe/Paris'), value: 'Europe/Paris'},
        {label: t('Europe/Brussels'), value: 'Europe/Brussels'},
        {label: t('Europe/Amsterdam'), value: 'Europe/Amsterdam'},
        {label: t('Europe/Berlin'), value: 'Europe/Berlin'},
        {label: t('Europe/Zurich'), value: 'Europe/Zurich'},
        {label: t('Europe/Rome'), value: 'Europe/Rome'},
        {label: t('Europe/Vienna'), value: 'Europe/Vienna'},
        {label: t('Europe/Prague'), value: 'Europe/Prague'},
        {label: t('Europe/Warsaw'), value: 'Europe/Warsaw'},
        {label: t('Europe/Stockholm'), value: 'Europe/Stockholm'},
        {label: t('Europe/Athens'), value: 'Europe/Athens'},
        {label: t('Europe/Helsinki'), value: 'Europe/Helsinki'},
        {label: t('Europe/Kyiv'), value: 'Europe/Kyiv'},
        {label: t('Europe/Istanbul'), value: 'Europe/Istanbul'},
        {label: t('Europe/Moscow'), value: 'Europe/Moscow'},

        {label: t('Africa/Casablanca'), value: 'Africa/Casablanca'},
        {label: t('Africa/Algiers'), value: 'Africa/Algiers'},
        {label: t('Africa/Cairo'), value: 'Africa/Cairo'},
        {label: t('Africa/Lagos'), value: 'Africa/Lagos'},
        {label: t('Africa/Johannesburg'), value: 'Africa/Johannesburg'},
        {label: t('Africa/Nairobi'), value: 'Africa/Nairobi'},
        {label: t('Asia/Jerusalem'), value: 'Asia/Jerusalem'},
        {label: t('Asia/Beirut'), value: 'Asia/Beirut'},
        {label: t('Asia/Riyadh'), value: 'Asia/Riyadh'},
        {label: t('Asia/Baghdad'), value: 'Asia/Baghdad'},
        {label: t('Asia/Tehran'), value: 'Asia/Tehran'},
        {label: t('Asia/Dubai'), value: 'Asia/Dubai'},

        {label: t('Asia/Kabul'), value: 'Asia/Kabul'},
        {label: t('Asia/Karachi'), value: 'Asia/Karachi'},
        {label: t('Asia/Kolkata'), value: 'Asia/Kolkata'},
        {label: t('Asia/Kathmandu'), value: 'Asia/Kathmandu'},
        {label: t('Asia/Dhaka'), value: 'Asia/Dhaka'},
        {label: t('Asia/Yangon'), value: 'Asia/Yangon'},
        {label: t('Asia/Bangkok'), value: 'Asia/Bangkok'},
        {label: t('Asia/Ho_Chi_Minh'), value: 'Asia/Ho_Chi_Minh'},
        {label: t('Asia/Singapore'), value: 'Asia/Singapore'},
        {label: t('Asia/Manila'), value: 'Asia/Manila'},
        {label: t('Asia/Jakarta'), value: 'Asia/Jakarta'},
        {label: t('Asia/Shanghai'), value: 'Asia/Shanghai'},
        {label: t('Asia/Hong_Kong'), value: 'Asia/Hong_Kong'},
        {label: t('Asia/Tokyo'), value: 'Asia/Tokyo'},
        {label: t('Asia/Seoul'), value: 'Asia/Seoul'},
        {label: t('Australia/Perth'), value: 'Australia/Perth'},
        {label: t('Australia/Adelaide'), value: 'Australia/Adelaide'},
        {label: t('Australia/Sydney'), value: 'Australia/Sydney'},
        {label: t('Australia/Brisbane'), value: 'Australia/Brisbane'},
        {label: t('Pacific/Auckland'), value: 'Pacific/Auckland'}
    ];
}